<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<app-nav-bar></app-nav-bar>

<div class="container">
  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>
  <div class="create-order-page">
    <!-- Header -->
    <div class="page-header">
      <div class="breadcrumb">
        <!-- <mat-icon class="breadcrumb-icon">edit_note</mat-icon>
        <span class="breadcrumb-separator">›</span> -->
        <h1 class="title">{{ 'CREATE_ORDER' | translate}}</h1>
      </div>
    </div>

    <div class="page-content">
      <!-- Left Column -->
      <div class="left-column">

        <!-- Products Card -->
        <div class="card products-card">
          <div class="card-header">
            <h2>{{ 'PRODUCTS' | translate}}</h2>
            <div class="card-header-actions">
              <button class="btn btn-outline" (click)="openSelectProductsModal()">
                <mat-icon>add</mat-icon> {{ 'ADD_PRODUCT' | translate}}
              </button>
              <!-- <button class="btn btn-icon" *ngIf="hasProducts">
                <mat-icon>more_horiz</mat-icon>
              </button> -->
            </div>
          </div>

          <!-- Products List -->
          <div class="products-list" *ngIf="hasProducts">
            <div class="product-row" *ngFor="let product of orderProducts; let i = index">
              <div class="product-image">
                <img [src]="product.imageURL || 'assets/static/missing-image.png'">
              </div>
              <div class="product-info">
                <span class="product-name">{{ product.productName }}</span>
                <span class="product-variant">
                  {{ product.variant }} &nbsp; {{ product.itemCode }}
                </span>
              </div>
              <div class="product-price">
                {{ formatCurrency(product.itemPrice) }}
              </div>
              <div class="product-quantity">
                <input
                  type="number"
                  [value]="product.amount"
                  min="1"
                  (change)="updateQuantity(i, $any($event.target).value)"
                  class="qty-input"
                >
              </div>
              <div class="product-line-total">
                {{ formatCurrency(product.lineTotal) }}
              </div>
              <button class="btn-remove" (click)="removeProduct(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state" *ngIf="!hasProducts">
            <p>{{ 'NO_PRODUCTS' | translate}}</p>
          </div>
        </div>

        <!-- Payment Card -->
        <div class="card payment-card">
          <div class="card-header">
            <h2>{{ 'PAYMENT' | translate}}</h2>
          </div>

          <div class="payment-details">
            <div class="payment-row">
              <span class="payment-label">{{ 'SUBTOTAL' | translate}}</span>
              <span class="payment-items" *ngIf="orderSummary.itemCount > 0">
                {{ orderSummary.itemCount }} {{ 'ITEMS' | translate}}
              </span>
              <span class="payment-value">{{ formatCurrency(orderSummary.subtotal) }}</span>
            </div>

            <!-- <div class="payment-row">
              <a class="payment-link" href="javascript:void(0)">Add discount</a>
              <span class="payment-dash">—</span>
              <span class="payment-value">{{ formatCurrency(orderSummary.discount) }}</span>
            </div>

            <div class="payment-row">
              <a class="payment-link" href="javascript:void(0)">Add shipping or delivery</a>
              <span class="payment-dash">—</span>
              <span class="payment-value">{{ formatCurrency(orderSummary.shipping) }}</span>
            </div>

            <div class="payment-row">
              <span class="payment-label">
                Estimated tax
                <mat-icon class="info-icon" matTooltip="Tax will be calculated at checkout">info</mat-icon>
              </span>
              <span class="payment-status" [class.not-calculated]="!orderSummary.taxCalculated">
                {{ orderSummary.taxCalculated ? formatCurrency(orderSummary.tax) : 'Not calculated' }}
              </span>
            </div> -->

            <div class="payment-row total-row">
              <span class="payment-label total-label">{{ 'TOTAL' | translate}}</span>
              <span class="payment-value total-value">{{ formatCurrency(orderSummary.total) }}</span>
            </div>
          </div>

          <!-- <div class="payment-footer" *ngIf="!hasProducts">
            Add a product to calculate total and view payment options
          </div> -->
          <!-- Botón Crear Orden (fijo en la parte inferior) -->
          <div class="create-order-footer">
            <button 
              class="btn-create-order" 
              (click)="createSale()" 
              [disabled]="isCreatingOrder || !hasProducts || !currentCustomer || currentShopPoint === null || !selectedPaymentMethod || !selectedOrderStatus"
            >
              <!-- Estado normal -->
              <span *ngIf="!isCreatingOrder" class="btn-content">
                <mat-icon>shopping_cart_checkout</mat-icon>
                {{ 'CREATE_ORDER' | translate}}
              </span>
              
              <!-- Estado loading -->
              <span *ngIf="isCreatingOrder" class="btn-content">
                <mat-spinner diameter="20" class="btn-spinner"></mat-spinner>
                {{ 'CREATING_ORDER' | translate}}
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="right-column">

        <!-- Notes Card -->
        <!-- <div class="card notes-card">
          <div class="card-header">
            <h2>{{ 'NOTES' | translate}}</h2>
            <button class="btn btn-icon" (click)="openAddNoteModal()">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div class="card-body" *ngIf="notes.length === 0">
            <p class="text-muted">{{ 'NO_NOTES' | translate}}</p>
          </div>
          <div class="card-body" *ngIf="notes.length > 0">
            <p *ngIf="notes">{{ notes }}</p>
          </div>
        </div> -->

        <!-- Order Details Card -->
        <div class="card order-details-card">
          <div class="card-header">
            <h2>{{ 'ORDER_DETAILS' | translate}}</h2>
          </div>

          <div class="card-body">
            <!-- Payment Method -->
            <div class="form-group">
              <label class="form-label">{{ 'PAYMENT_METHOD' | translate}}</label>
              <select 
                class="form-select" 
                [(ngModel)]="selectedPaymentMethod"
                (change)="onOrderDetailsChange()"
              >
                <option *ngFor="let paymentType of paymentTypes" [value]="paymentType.paymentTypeId" >
                  {{ paymentType.paymentTypeName }} {{ paymentType.paymentTypeName.toLowerCase() == "tarjeta de crédito"? "- "+paymentType.paymentTypeCode : ''}}
                </option>
              </select>
            </div>

            <!-- Sucursal -->
            <div class="form-group" *ngIf="shopPoints && shopPoints.length > 0">
              <label class="form-label">{{ 'SHOP_POINT' | translate}}</label>
              <select 
                class="form-select" 
                [(ngModel)]="currentShopPoint"
                (change)="onOrderDetailsChange()"
              >
                <option *ngFor="let shopPoint of shopPoints" [value]="shopPoint.shopPointId" [selected]="shopPoint.shopPointId === currentShopPoint">
                  {{ shopPoint.shopPointName }}
                </option>
              </select>
            </div>

            <!-- Order Status -->
            <div class="form-group">
              <label class="form-label">{{ 'ORDER_STATUS' | translate}}</label>
              <select 
                class="form-select" 
                [(ngModel)]="selectedOrderStatus"
                (change)="onOrderDetailsChange()"
              >
                <!-- <option value="" disabled>{{ 'SELECT_ORDER_STATUS' | translate}}</option> -->
                <option *ngFor="let status of orderStatuses" [value]="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Customer Card -->
        <div class="card customer-card">
          <div class="card-header">
            <h2>{{ 'CUSTOMER' | translate}}</h2>
            <!-- <button class="btn btn-icon" *ngIf="currentCustomer">
              <mat-icon>more_horiz</mat-icon>
            </button> -->
          </div>

          <!-- No customer selected -->
          <div class="card-body" *ngIf="!currentCustomer && !isCreatingNewCustomer">
            <div class="customer-search-wrapper">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                class="customer-search-input"
                placeholder="Search or create a customer"
                [value]="customerSearchQuery"
                (input)="onCustomerSearchChange($any($event.target).value)"
                (focus)="onCustomerFocus()"
                (blur)="showCustomerResults = false"
              >
            </div>

            <!-- Search Results Dropdown -->
            <div class="search-results-dropdown" *ngIf="showCustomerResults">
              <div class="search-result-item create-new" (mousedown)="toggleNewCustomer()">
                <mat-icon>add</mat-icon>
                <span>{{ 'CREATE_NEW_CUSTOMER' | translate}}</span>
              </div>
              <div
                class="search-result-item"
                *ngFor="let customer of customerSearchResults"
                (mousedown)="selectCustomer(customer)"
              >
                <span class="result-name">{{ customer.firstName + ' ' + customer.lastName }}</span>
                <span class="result-email">{{ customer.email }}</span>
              </div>
            </div>
          </div>

          <!-- Customer Selected -->
          <div class="card-body" *ngIf="currentCustomer">
            <div class="customer-info">
              <h5>{{ currentCustomer.name }} {{ currentCustomer.firstName+ ' ' + currentCustomer.lastName }}</h5>
            </div>

            <div class="customer-section contact-section">
              <!-- <h3>{{ 'CONTACT_INFORMATION' | translate}}</h3> -->
              <div class="contact-list">
                <!-- Email -->
                <div class="contact-item" *ngIf="currentCustomer.email">
                  <div class="contact-icon email-icon">
                    <mat-icon>email</mat-icon>
                  </div>
                  <div class="contact-content">
                    <span class="contact-label">{{ 'EMAIL' | translate}}</span>
                    <a class="contact-value" [href]="'mailto:' + currentCustomer.email">
                      {{ currentCustomer.email }}
                    </a>
                  </div>
                </div>

                <!-- National ID -->
                <div class="contact-item" *ngIf="currentCustomer.nationalId">
                  <div class="contact-icon id-icon">
                    <mat-icon>badge</mat-icon>
                  </div>
                  <div class="contact-content">
                    <span class="contact-label">{{ 'NATIONAL_ID' | translate}}</span>
                    <span class="contact-value">{{ currentCustomer.nationalId }}</span>
                  </div>
                </div>

                <!-- Phone -->
                <div class="contact-item" *ngIf="currentCustomer.phone">
                  <div class="contact-icon phone-icon">
                    <mat-icon>phone</mat-icon>
                  </div>
                  <div class="contact-content">
                    <span class="contact-label">{{ 'PHONE' | translate}}</span>
                    <a class="contact-value" [href]="'tel:' + currentCustomer.phone">
                      {{ currentCustomer.phone }}
                    </a>
                  </div>
                </div>

                <!-- Mensaje si no hay datos -->
                <div class="contact-empty" *ngIf="!currentCustomer.email && !currentCustomer.nationalId && !currentCustomer.phone">
                  <mat-icon>info</mat-icon>
                  <span>{{ 'NO_CONTACT_INFORMATION' | translate}}</span>
                </div>
              </div>
            </div>

            <!-- Botón Cambiar cliente -->
            <button class="btn-change-customer" (click)="clearCustomer()">
              {{ 'CHANGE_CUSTOMER' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 

<!-- Modal de Resultado (Bootstrap 5) -->
<div class="modal fade" id="resultModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center p-4">
        
        <!-- Icono de éxito -->
        <div class="result-icon success-icon" *ngIf="resultModalType === 'success'">
          <i class="bi bi-check-circle-fill"></i>
        </div>
        
        <!-- Icono de error -->
        <div class="result-icon error-icon" *ngIf="resultModalType === 'error'">
          <i class="bi bi-x-circle-fill"></i>
        </div>

        <!-- Título -->
        <h5 class="modal-title mt-3 mb-2">
          {{ resultModalType === 'success' ? 'Success' : 'Error' }}
        </h5>

        <!-- Mensaje -->
        <p class="text-muted mb-4">{{ resultModalMessage }}</p>

        <!-- Botón cerrar -->
        <button 
          type="button" 
          class="btn w-auto"
          [ngClass]="resultModalType === 'success' ? 'btn-success' : 'btn-danger'"
          data-bs-dismiss="modal"
        >
          {{ resultModalType === 'success' ? 'Continue' : 'Close' }}
        </button>
      </div>
    </div>
  </div>
</div>